//export const BASE_URL = 'http://localhost:3001'
export const BASE_URL = 'https://jace-medical-ambulance-api.onrender.com'
//export const WS_URL = 'http://localhost:3001'
export const WS_URL = 'https://jace-medical-ambulance-api.onrender.com'